import React from "react";
import PropTypes from "prop-types";
import SvgIcon from "@mui/material/SvgIcon";

export default function ArrowUpIcon(props) {
  return (
    <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path d="M13.4409 9.88909C13.5841 9.74594 13.6543 9.58569 13.6516 9.40834C13.649 9.231 13.576 9.07075 13.4329 8.9276L10.5627 6.05741C10.4708 5.96552 10.3781 5.90008 10.2847 5.86109C10.1912 5.82209 10.0942 5.8026 9.9938 5.8026C9.89337 5.8026 9.79642 5.82209 9.70294 5.86109C9.60946 5.90008 9.51678 5.96552 9.4249 6.05741L6.53388 8.94843C6.4046 9.07769 6.33997 9.231 6.33997 9.40834C6.33997 9.58569 6.41155 9.74594 6.55472 9.88909C6.69787 10.0323 6.85678 10.1038 7.03147 10.1038C7.20613 10.1038 7.36505 10.0323 7.50822 9.88909L9.32715 8.07016V13.5333C9.32715 13.7107 9.39392 13.8661 9.52747 13.9997C9.66101 14.1332 9.81645 14.2 9.9938 14.2C10.1711 14.2 10.3266 14.1332 10.4601 13.9997C10.5937 13.8662 10.6604 13.7107 10.6604 13.5333V8.07016L12.5002 9.90993C12.6295 10.0392 12.7828 10.1038 12.9602 10.1038C13.1375 10.1038 13.2977 10.0323 13.4409 9.88909Z" fill={props.color}/>
    </SvgIcon>
  );
}

ArrowUpIcon.propTypes = {
  color: PropTypes.string
};